import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { included, images } from "../../data/landing";
import { SectionHeading } from "../SectionHeading";
import { TransformCta } from "../TransformCta";
export function Included() {
  return <section className="px-5 py-16" data-id="element-184" data-mp="2xl2c9wc6wcj3">
      <SectionHeading title="Everything you need to organize your clinical reference workflow" lead="With Diabetes Clinical Blueprint, you receive:" data-id="element-185" data-mp="32l6vvv8e9ndj" />
      <div className="mx-auto mt-8 grid max-w-5xl items-center gap-8 md:grid-cols-2" data-id="element-186" data-mp="37k1kxewyg863">
        <img src={images.mockup} alt="Complete Diabetes Clinical Blueprint collection" className="w-full" loading="lazy" data-id="element-187" data-mp="3bktvqclh6l4h" />
        <ul className="space-y-3" data-id="element-188" data-mp="3gdmy4tth1hde">
          {included.map(t => <li key={t} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 text-[17px] font-semibold text-ink shadow-sm ring-1 ring-navy/5" data-id="element-189" data-mp="3lamw0hg63dtf">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-cta" aria-hidden="true" data-id="element-190" data-mp="3va5gr03wj3mj" />
              {t}
            </li>)}
        </ul>
      </div>
      <p className="mx-auto mt-8 max-w-2xl text-center text-sm italic leading-relaxed text-muted" data-id="element-191" data-mp="2r4wn47n7hup8">
        This is not intended to replace clinical training, current guidelines, or professional judgment. It is a practical reference collection designed to help you organize the information and review processes that support your work.
      </p>
      <TransformCta label="Yes, I want the complete Blueprint" data-id="element-192" data-mp="39tjskr9aom3c" />
    </section>;
}